import React, { useRef } from "react";
import Style from "./index.module.scss";
import { Spin } from "antd";

interface FileUploaderProps {
    buttonClass?: string;
    buttonText?: string;
    loading?: boolean;
    onFileSelect: (files: File[]) => void;
    children?: React.ReactChild;
}

export default function FileSelect({
    buttonClass,
    loading,
    children,
    buttonText = "点击上传",
    onFileSelect
}: FileUploaderProps) {
    const fileRef = useRef<any>(null);
    function onChange() {
        onFileSelect(fileRef.current.files);
    }
    function onClick() {
        fileRef.current.value = "";
    }
    return (
        <div className={buttonClass} onClick={onClick}>
            {!children && (
                <Spin spinning={loading}>
                    <div className={Style.btn}>
                        {!loading && (
                            <label htmlFor="input">{buttonText}</label>
                        )}
                    </div>
                </Spin>
            )}
            {children && <label htmlFor="input">{children}</label>}
            <input
                ref={fileRef}
                type="file"
                id="input"
                style={{ display: "none" }}
                multiple
                onChange={onChange}
            />
        </div>
    );
}
